module.exports = __webpack_public_path__ + "static/media/lv2-3.a8b36ef5.mp3";